<mat-dialog-content>
  <p class="text-center">
    {{ message }}
  </p>
  <div *ngIf="showRepayMoney" class="text-center-mt-20">
    <mat-checkbox [(ngModel)]="repayMoney" color="primary">
      {{ repayMoneyText }}
    </mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="mb-3" align="center">
  <button mat-raised-button color="primary" (click)="onConfirmClick()" tabindex="1">{{ confirmButtonText }}</button>
  <button mat-raised-button mat-dialog-close tabindex="-1">{{ cancelButtonText }}</button>
</mat-dialog-actions>